import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';

class ComingSoon extends PureComponent {

  render() {
    return (
      <>
        <Helmet>
          <title>BetXchange - Coming Soon</title>
        </Helmet>
        <div style={ { background: '#FFFFFF', padding: '8px', height: '100%' } }>Coming Soon.</div>
      </>
    );
  }
}

export default ComingSoon;
